import script from "./FindPwd.vue?vue&type=script&lang=ts&setup=true"
export * from "./FindPwd.vue?vue&type=script&lang=ts&setup=true"

import "./FindPwd.vue?vue&type=style&index=0&id=4adcc461&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4adcc461"]])

export default __exports__